<template lang="pug">
  footer.app-footer.flex.flex-col.md-block.mt-200(v-if="site", v-show="!isHidden")
    //- locations
    template(v-if="!hideAddr")
      //- (laptop)
      .px-20.lg-w-xl.mx-auto.mb-140(v-if="winIs('md')")
        //- address
        //- TODO - maybe can used css grid so markup is correct...
        .flex.justify-evenly.w-grid-20.-mx-20.px-10
          .w-1x4.px-10(v-for="location in site.locations")
            address.text-13(v-html="r(location.address)")
        //- spaces
        .flex.justify-evenly.w-grid-20.-mx-20.px-10.my-40
          .w-1x4.px-10(v-for="location in site.locations")
            nav.text-17.links-hover-text-blue(v-html="r(location.spaces)")
        //- hours
        .flex.justify-evenly.w-grid-20.-mx-20.px-10
          .w-1x4.px-10(v-for="location in site.locations")
            small.block.text-13(v-html="r(location.hours)")
      //- (mobile)
      section(v-else)
        //- locations...
        ul.border-t.list-reset(v-for="(location, i) in site.locations")
          li.flex.items-start.pt-18.cursor-pointer(@click="toggleItem(i, expanded)")
            button.pl-18.pr-12.text-17.flex.items-center(aria-label="Toggle Location Details")
              svg-plus-minus(style="width:1.6rem;height:1.6rem", :minus="expanded.includes(i)")
              | &nbsp;
            .pr-30
              header.text-17.pb-18
                .inline-block.pointer-events-none(v-html="r(location.spaces)")
              dropdown-animate(:open="expanded.includes(i)")
                .text-13.pb-18
                  address(v-html="r(location.address)")
                  small.block.mt-20(v-html="r(location.hours)", v-if="location.hours.length")

    //- social / mailing list
    social-btns.my-82.md-mt-0.md-mb-164
    //- cookies, copyright
    .pb-12.flex.items-end.justify-between.md-p-0
      ul.flex-1.px-15.md-px-6.py-2.text-13.flex.flex-wrap
        li.w-full.sm-w-auto.md-mr-20.mt-15.sm-mt-0(v-for="item in site.footer_links_left")
          wp-link.btn-theme-text(:link='item.link') {{ item.link.title }}
      small.block.px-15.md-px-6.py-2.text-13.whitespace-no-wrap © Blue Mountain School {{now.getFullYear()}}
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { resolveAllLinks, toggleItem } from '@/utils'
import SocialBtns from '@/components/SocialBtns'
import svgPlusMinus from '@/components/Icons/SVG-PlusMinus'
export default {
  name: 'AppFooter',
  data () {
    return {
      r: resolveAllLinks,
      now: new Date(),
      expanded: [],
      toggleItem
    }
  },
  computed: {
    ...mapState(['site']),
    ...mapGetters(['winIs']),
    isHidden () {
      return this.$route.meta.footer === false
    },
    hideAddr () {
      const isLibrary = this.$route.path.indexOf('/library') === 0
      return isLibrary || this.$route.params.slug === 'locations'
    }
  },
  components: { SocialBtns, svgPlusMinus }
}
</script>

<style>
</style>
